<template>
    <div class="business-customer-switch is-flex" @click.stop>
        <div
            v-if="
                ![viewports.MOBILE.name, viewports.TABLET.name].includes(
                    currentViewport
                )
            "
            class="is-flex is-align-items-center"
        >
            <span>{{
                $t('checkout.paymentDetails.inputLabels.privateCustomer')
            }}</span>
            <label class="switch mx-3">
                <input type="checkbox" v-model="isBusinessCustomer" />
                <span class="switch__slider round"></span>
            </label>
            <span>{{
                $t('checkout.paymentDetails.inputLabels.businessCustomer')
            }}</span>
        </div>
        <div v-else>
            <div>
                {{
                    $t(
                        'checkout.paymentDetails.inputLabels.businessOrPrivateCustomer'
                    )
                }}
            </div>
            <div class="is-flex is-align-items-center">
                <label class="switch mr-3">
                    <input type="checkbox" v-model="isBusinessCustomer" />
                    <span class="switch__slider round"></span>
                </label>
                <span v-if="!isBusinessCustomer">{{
                    $t('checkout.paymentDetails.inputLabels.privateCustomer')
                }}</span>
                <span v-else>{{
                    $t('checkout.paymentDetails.inputLabels.businessCustomer')
                }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { viewports } from '../../../store/constants/viewports';

export default {
    name: 'BusinessCustomerSwitch',
    data() {
        return { viewports: viewports };
    },
    computed: {
        ...mapGetters(['userPreferences']),
        currentViewport() {
            return this.$store.getters['currentViewport'];
        },
        isBusinessCustomer: {
            get() {
                return this.userPreferences.isBusinessCustomer.value;
            },
            set(value) {
                this.$store.dispatch('updateUserPreferences', {
                    isBusinessCustomer: { value, isSet: true },
                });
            },
        },
    },
};
</script>
<style lang="scss"></style>
